import MapboxDraw from '@mapbox/mapbox-gl-draw';

const SimpleSelectMode = MapboxDraw.modes.simple_select;

const _onDrag = SimpleSelectMode.onDrag;

SimpleSelectMode.onDrag = function (state, e) {
  if (state?.boxSelecting) {
    return _onDrag?.apply(this, [state, e]);
  }

  return;
};

export default SimpleSelectMode;
